export default "__VITE_ASSET__d75999e4__"